module.exports = __webpack_public_path__ + "img/refreshSigh.8e65a146.svg";